export type RunTierId = 'frost' | 'carve' | 'momentum' | 'exposure' | 'whiteout' | 'aurora';

export interface RunTier {
  id: RunTierId;
  index: number;
  name: string;
  min: number;
  next: number | null;
  color: string;
  rgb: [number, number, number];
  description: string;
}

export const RUN_TIERS: readonly RunTier[] = [
  { id: 'frost',    index: 0, name: 'Frost',    min: 1,   next: 1.5, color: '#60a5fa', rgb: [96, 165, 250], description: 'Cold start' },
  { id: 'carve',    index: 1, name: 'Carve',    min: 1.5, next: 2.5, color: '#2dd4bf', rgb: [45, 212, 191], description: 'Find the line' },
  { id: 'momentum', index: 2, name: 'Momentum', min: 2.5, next: 5,   color: '#9cff57', rgb: [156, 255, 87], description: 'The mountain accelerates' },
  { id: 'exposure', index: 3, name: 'Exposure', min: 5,   next: 10,  color: '#f0b429', rgb: [240, 180, 41], description: 'Conditions turn' },
  { id: 'whiteout', index: 4, name: 'Whiteout', min: 10,  next: 25,  color: '#ff5864', rgb: [255, 88, 100], description: 'Visibility critical' },
  { id: 'aurora',   index: 5, name: 'Aurora',   min: 25,  next: null,color: '#d8b4fe', rgb: [216, 180, 254], description: 'Beyond the storm' },
];

export function getRunTier(multiplier: number): RunTier {
  const value = Number.isFinite(multiplier) ? Math.max(1, multiplier) : 1;
  for (let index = RUN_TIERS.length - 1; index >= 0; index--) {
    if (value >= RUN_TIERS[index].min) return RUN_TIERS[index];
  }
  return RUN_TIERS[0];
}

export function getRunTierProgress(multiplier: number): number {
  const tier = getRunTier(multiplier);
  if (tier.next === null) return 1;
  return Math.max(0, Math.min(1, (multiplier - tier.min) / (tier.next - tier.min)));
}

export function getNextRunTier(multiplier: number): RunTier | null {
  const tier = getRunTier(multiplier);
  return RUN_TIERS[tier.index + 1] ?? null;
}
